import React from "react";
import { useContext } from 'react';
import { motion } from "framer-motion";
import "./Modelo.css";
import "components/proyecto/container/ProjectDetails.css";
import AccordionBullets from "./AccordionBullets";
import { useNavigate } from "react-router-dom";
import Link from '@mui/material/Link';
import { AuthContext } from 'global/context/authContextDefinition';
import ModeloLogeado from "./ModeloLogeado";
import ModeloDeslogeado from "./ModeloDeslogeado";
import { useAuth } from 'global/context/AuthProviderV2';

/**
 * Componente que muestra el contenido estático del documento
 * "Nivel de Madurez Multidimensional de EBCTs" con la misma
 * estructura de secciones que aparece en Notion. 
 * Se agregan divs de placeholder para que configures o subas
 * tus imágenes según necesites.
 */
function ModeloHome() {
    //const authContext = useContext(AuthContext);
    const { isAuthenticated } = useAuth();

  
    const rlItems = [
        { id: "1", title: "CRL (Customer Readiness Level):", content: "Evalúa la preparación del proyecto en relación con su base de clientes." },
        { id: "2", title: "BRL (Business Readiness Level):", content: "Evalúa la preparación del negocio, la propuesta de valor y el potencial de mercado." },
        { id: "3", title: "TRL (Technology Readiness Level):", content: "Mide la madurez de la tecnología subyacente y su grado de validación." },
        { id: "4", title: "IPRL (Intellectual Property Readiness Level):", content: "Se refiere a la protección y gestión de la propiedad intelectual." },
        { id: "5", title: "TmRL (Team Readiness Level):", content: "Valora la madurez del equipo gestor y el grado de experiencia/habilidades." },
        { id: "6", title: "FRL (Funding Readiness Level):", content: "Considera la disponibilidad y la estrategia de financiamiento." },
    ];

    const navigate = useNavigate()

    return (
        <div>
            {/*isAuthenticated?
        (<ModeloLogeado></ModeloLogeado>)
        :
        (<ModeloDeslogeado></ModeloDeslogeado>)    
        */}
         <ModeloDeslogeado></ModeloDeslogeado>
        </div>
    );
}

  function Modelo() {
    //const authContext = useContext(AuthContext);
    const { isAuthenticated } = useAuth();

  
    const rlItems = [
        { id: "1", title: "CRL (Customer Readiness Level):", content: "Evalúa la preparación del proyecto en relación con su base de clientes." },
        { id: "2", title: "BRL (Business Readiness Level):", content: "Evalúa la preparación del negocio, la propuesta de valor y el potencial de mercado." },
        { id: "3", title: "TRL (Technology Readiness Level):", content: "Mide la madurez de la tecnología subyacente y su grado de validación." },
        { id: "4", title: "IPRL (Intellectual Property Readiness Level):", content: "Se refiere a la protección y gestión de la propiedad intelectual." },
        { id: "5", title: "TmRL (Team Readiness Level):", content: "Valora la madurez del equipo gestor y el grado de experiencia/habilidades." },
        { id: "6", title: "FRL (Funding Readiness Level):", content: "Considera la disponibilidad y la estrategia de financiamiento." },
    ];

    const navigate = useNavigate()

    return (
        <div>
            {isAuthenticated?
                (<ModeloLogeado></ModeloLogeado>)
                :
                (<ModeloDeslogeado></ModeloDeslogeado>)    
            }
        </div>
    );
}

export {Modelo, ModeloHome}